import { render, staticRenderFns } from "./ProductCardAddToCart.vue?vue&type=template&id=638d55a8&"
import script from "./ProductCardAddToCart.vue?vue&type=script&lang=js&"
export * from "./ProductCardAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default})
